import { Box } from '@wix/design-system';
import React, { FC } from 'react';

import { IButtonItem } from '../../../common/messageCreators';
import { ButtonsDefaultItem } from './ButtonsDefaultItem';

type ButtonsDefaultProps = {
  items: IButtonItem[];
  onClick: (btn: IButtonItem, position: number) => void;
};

export const ButtonsDefault: FC<ButtonsDefaultProps> = ({ items, onClick }) => {
  return (
    <Box gap="SP1" flexWrap="wrap">
      {items.map((item, i) => (
        <ButtonsDefaultItem key={item._id} item={item} position={i} onClick={onClick} />
      ))}
    </Box>
  );
};
